<template>
  <bwr-form-field type="dropdown">
    <icon-chevron />
    <select
      class="FormField__Input FormField__Input--select"
      :value="value"
      :disabled="disabled"
      @change.stop="$emit('change', $event.target.value)"
    >
      <slot />
    </select>
    <div class="FormField__InputOverflowFade" />
  </bwr-form-field>
</template>

<script>
import BwrFormField from './BaseFormField.vue'
import IconChevron from '@/components/icons/IconChevron.vue'

export default {
  name: 'BwrSelect',
  components: {
    IconChevron,
    BwrFormField,
  },
  props: {
    value: {
      /* type is any */
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style>
.FormField .FormField__Input--select {
  appearance: none;
  outline: none;
  font-family: var(--font-family-rund);
  color: var(--color-forest-100);
  padding: 9px 20px 10px 10px;
  font-size: 15px;
  line-height: 17px;
  background: none;
  background-color: var(--color-white);
  border: 1px solid var(--color-lichen-150);
  border-radius: 4px;
  position: relative;
  width: 100%;
  text-overflow: ellipsis;
}

.FormField__InputOverflowFade {
  position: absolute;
  top: 5px;
  right: 1px;
  bottom: 5px;
  width: 33px;
  content: '';
  background: linear-gradient(
    to right,
    rgba(var(--rgb-white), 0),
    var(--color-white) 20%
  );
  pointer-events: none;
}

.FormField__Input--select[disabled] + .FormField__InputOverflowFade {
  background: linear-gradient(
    to right,
    rgba(var(--rgb-lichen-100), 0),
    var(--color-lichen-100) 20%
  );
}

.FormField .FormField__Input--select[disabled] {
  background-color: var(--color-lichen-100);
  color: var(--color-forest-80);
}

.FormField--dropdown > .Icon {
  pointer-events: none;
  position: absolute;
  right: 12px;
  top: 50%;
  margin-top: -4px;
  z-index: 1;
  width: 12px;
  height: 8px;
  line-height: 1;
}
</style>
